import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./DescriptionEllipsis.scss";
import { renderHTML } from "../../utils/misc";
import classnames from "classnames";

class DescriptionEllipsis extends Component {
  constructor(props) {
    super(props);
    this.extractContent = this.extractContent.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  extractContent(text) {
    const span = document.createElement("span");
    span.innerHTML = text.replace(new RegExp("&nbsp;", "g"), " ");
    const parsedText = span.textContent || span.innerText;
    return parsedText;
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.handleModal();
  }

  render() {
    const { extractContent, handleClick } = this;
    const { text, type, lines } = this.props;
    return (
      <div
        className={classnames(
          styles.container,
          "wbkv9-DescriptionEllipsis",
          type === "entity" && styles.entity,
          type === "service" && styles.service,
          lines === 2 && styles.twoLines,
          lines === 3 && styles.threeLines
        )}>
        <span className={styles.text} dangerouslySetInnerHTML={renderHTML(extractContent(text))} />
        <div className={classnames("descriptionEllipsis", styles.ellipsis)}>
          ...{" "}
          <span className={styles.moreInfo} onClick={handleClick}>
            +info
          </span>
        </div>
      </div>
    );
  }
}

DescriptionEllipsis.propTypes = {
  text: PropTypes.string.isRequired,
  handleModal: PropTypes.func,
  type: PropTypes.string,
  limit: PropTypes.number,
  lines: PropTypes.number,
  statusCode: PropTypes.string,
  expanded: PropTypes.bool,
};

DescriptionEllipsis.defaultProps = {
  text: "",
  handleModal() {},
  type: "",
};

export default DescriptionEllipsis;
